export const Step = {
    FeedUrl: 'FeedUrl',
    ShowInformation: 'ShowInformation',
    ShowDetails: 'ShowDetails',
    Plans: 'Plans',
    Payment: 'Payment',
    Success: 'Success',
};

export const steps = {
    feed: [
        Step.FeedUrl,
        Step.ShowInformation,
        Step.Plans,
        Step.Payment,
        Step.Success,
    ],
    hosted: [
        Step.ShowDetails,
        Step.Plans,
        Step.Payment,
        Step.Success,
    ],
};
